// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//     this.bundleSync();

//     // this.bundleObserver = new MutationObserver(() => {

//     //   clearTimeout(this.bundleTimer);
//     //   this.bundleTimer = setTimeout(() => {
//     //     this.bundleSync();
//     //   }, 200);
//     // });
//     this.bundleObserver = new MutationObserver(() => {
//   clearTimeout(this.bundleTimer);

//   this.bundleTimer = setTimeout(() => {
//     requestAnimationFrame(() => {
//       this.bundleSync();

//       // IMPORTANT: rebind timer safely
  
//     });
//   }, 250);
// });

//     this.bundleObserver.observe(this, {
//       childList: true,
//       subtree: true
//     });
//   }




  
//   bundleSync() {

//     const addonEl = document.getElementById('addon-free-product');

//     if (!addonEl) {
//       return;
//     }

//     let addonIds = [];

//     try {
//       const parsed = JSON.parse(addonEl.textContent || '[]');
//       addonIds = Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
//     } catch (e) {
//       return;
//     }

//     const addonId = addonIds[addonIds.length - 1];

//     const cartItems = [...this.querySelectorAll('.cart-item')];

//     if (!cartItems.length) {
//       return;
//     }

//     const addonItem = cartItems.find(item => Number(item.dataset.key) === addonId);

//     if (!addonItem) {
//       return;
//     }

//     const addonInput = addonItem.querySelector('.quantity__input');

//     const excludedIds = new Set([
//       addonId,
//       ...addonIds
//     ]);

//     let mainItems = cartItems.filter(item => {
//       const id = Number(item.dataset.key);
//       return !excludedIds.has(id);
//     });

//     let totalQty = 0;

//     mainItems.forEach(item => {
//       const input = item.querySelector('.quantity__input');
//       const qty = parseInt(input?.value || 0, 10);


//       totalQty += qty;
//     });


//     if (totalQty === 0) {
//       this.clearCartAndRefreshUI();
//       return ;
//     }

//     // ❌ DO NOT update addon if missing input or invalid
//     if (!addonInput) {
//       return;
//     }

//     const current = parseInt(addonInput.value, 10);


//     // 🔥 NORMAL SYNC
//     if (current !== totalQty) {

//       addonInput.value = totalQty;

//       addonInput.dispatchEvent(
//         new Event('change', { bubbles: true })
//       );
//     } else {
//     }
//   }

//   async clearCartAndRefreshUI() {
//   try {

//     // 1. Clear cart
//     const res = await fetch('/cart/clear.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     await res.json();

//     // 2. Get full Shopify cart state (IMPORTANT)
//     const updated = await fetch('/cart.js');
//     const cart = await updated.json();

//     // 3. Get fresh sections from Shopify
//     const sectionsRes = await fetch(
//       '/?sections=cart-drawer,cart-icon-bubble'
//     );

//     const sections = await sectionsRes.json();

//     // 4. Call renderContents properly
//     this.renderContents({
//       id: null,
//       sections: sections,
//       cart: cart
//     });

//     const myDrawer = document.querySelector('cart-drawer');

//     if (myDrawer) {
//       myDrawer.classList.add('is-empty');
//     }
//   } catch (error) {
//   }

 
// }
  
//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     if (!cartLink) return;

//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add('animate', 'active');
  
//     });

//     this.addEventListener(
//       'transitionend',
//       () => {
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');
//     setTimeout(() => {
//       requestAnimationFrame(() => {
//         this.bundleSync();
//       });
//     }, 300);
    
//   }

//   close() {
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') &&
//       this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);

//       if (!sectionElement) return;
//       sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     });

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//     setTimeout(() => {
//       this.bundleSync();
//     }, 400);
//   }
// }
// customElements.define('cart-drawer-items', CartDrawerItems);

// ============================================================
// CART TIMER UTILITIES runnoig code start from here
// ============================================================

// const CART_TIMER_KEY = 'cartTimerEnd';
// const CART_TIMER_DURATION_MS = 10 * 60 * 1000; // 10 minutes
// const CART_TIMER_EXPIRED_MSG = 'Your cart is running out! Complete your order now.';

// let cartTimerInterval = null;

// function getTimerEls() {
//   return {
//     display: document.querySelector('#countdown'),
//     text: document.querySelector('#timer-text'),
//   };
// }

// function formatCartTime(seconds) {
//   const m = String(Math.floor(seconds / 60)).padStart(2, '0');
//   const s = String(seconds % 60).padStart(2, '0');
//   return `${m}:${s}`;
// }

// function stopCartTimer() {
//   if (cartTimerInterval) {
//     clearInterval(cartTimerInterval);
//     cartTimerInterval = null;
//   }
// }

// function showCartTimerExpired() {
//   const { display, text } = getTimerEls();
//   if (display) display.textContent = '00:00';
//   if (text) text.textContent = CART_TIMER_EXPIRED_MSG;
// }

// function startCartTimer(forceReset) {
//   stopCartTimer();

//   const { display } = getTimerEls();
//   if (!display) return;

//   let endTime = localStorage.getItem(CART_TIMER_KEY);

//   if (!endTime || forceReset) {
//     endTime = Date.now() + CART_TIMER_DURATION_MS;
//     localStorage.setItem(CART_TIMER_KEY, String(endTime));
//   } else {
//     endTime = parseInt(endTime, 10);
//     if (Date.now() >= endTime) {
//       showCartTimerExpired();
//       return;
//     }
//   }

//   function tick() {
//     const { display: d } = getTimerEls(); // re-query each tick — Dawn replaces DOM
//     const remaining = Math.floor((endTime - Date.now()) / 1000);
//     if (remaining <= 0) {
//       stopCartTimer();
//       localStorage.removeItem(CART_TIMER_KEY);
//       showCartTimerExpired();
//       return;
//     }
//     if (d) d.textContent = formatCartTime(remaining);
//   }

//   tick();
//   cartTimerInterval = setInterval(tick, 1000);
// }

// function handleCartTimerState(itemCount) {
//   if (itemCount === 0) {
//     stopCartTimer();
//     localStorage.removeItem(CART_TIMER_KEY);
//     return;
//   }
//   const stored = localStorage.getItem(CART_TIMER_KEY);
//   if (stored && Date.now() >= parseInt(stored, 10)) {
//     localStorage.removeItem(CART_TIMER_KEY);
//     startCartTimer(true);
//     return;
//   }
//   startCartTimer(!stored);
// }

// // ============================================================
// // CART DRAWER running Correct JS
// // ============================================================

// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();

//     // ── Flags to prevent bundleSync feedback loops ──
//     this._bundleSyncing = false;   // true while we are mid-sync
//     this._observerPaused = false;  // true while observer should be silent

//     this.bundleSync();

//     // Debounced MutationObserver — only fires after DOM settles (300 ms)
//     // and is completely silent while bundleSync is running.
//     this.bundleObserver = new MutationObserver(() => {
//       if (this._observerPaused) return; // skip — we caused this mutation

//       clearTimeout(this.bundleTimer);
//       this.bundleTimer = setTimeout(() => {
//         requestAnimationFrame(() => {
//           this.bundleSync();
//         });
//       }, 300);
//     });

//     this.bundleObserver.observe(this, {
//       childList: true,
//       subtree: true,
//     });
//   }

//   // ── Pause / resume observer around our own DOM writes ────
//   _pauseObserver() {
//     this._observerPaused = true;
//   }

//   _resumeObserver() {
//     // Small delay so any synchronous DOM mutations we caused are
//     // already delivered (and ignored) before we start listening again.
//     setTimeout(() => {
//       this._observerPaused = false;
//     }, 50);
//   }

//   bundleSync() {
//     // Guard: prevent re-entrant calls
//     if (this._bundleSyncing) return;

//     const addonEl = document.getElementById('addon-free-product');
//     if (!addonEl) return;

//     let addonIds = [];
//     try {
//       const parsed = JSON.parse(addonEl.textContent || '[]');
//       addonIds = Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
//     } catch (e) {
//       return;
//     }

//     const addonId = addonIds[addonIds.length - 1];
//     const cartItems = [...this.querySelectorAll('.cart-item')];
//     if (!cartItems.length) return;

//     const addonItem = cartItems.find(item => Number(item.dataset.key) === addonId);
//     if (!addonItem) return;

//     const addonInput = addonItem.querySelector('.quantity__input');

//     const excludedIds = new Set([addonId, ...addonIds]);

//     const mainItems = cartItems.filter(item => !excludedIds.has(Number(item.dataset.key)));

//     let totalQty = 0;
//     mainItems.forEach(item => {
//       const input = item.querySelector('.quantity__input');
//       totalQty += parseInt(input?.value || 0, 10);
//     });

//     if (totalQty === 0) {
//       this.clearCartAndRefreshUI();
//       return;
//     }

//     if (!addonInput) return;

//     const current = parseInt(addonInput.value, 10);
//     if (current === totalQty) return; // nothing to do — exit without any mutation

//     // ── Write to the addon input without triggering the observer ──
//     this._bundleSyncing = true;
//     this._pauseObserver();

//     addonInput.value = totalQty;
//     addonInput.dispatchEvent(new Event('change', { bubbles: true }));

//     // Give Dawn's CartItems handler time to finish its fetch + re-render,
//     // then re-enable the observer and clear the sync flag.
//     // 600 ms covers Dawn's typical debounce (300 ms) + network round-trip.
//     setTimeout(() => {
//       this._bundleSyncing = false;
//       this._resumeObserver();
//     }, 600);
//   }

//   async clearCartAndRefreshUI() {
//     try {
//       const res = await fetch('/cart/clear.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//       });
//       await res.json();

//       const updated = await fetch('/cart.js');
//       const cart = await updated.json();

//       const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
//       const sections = await sectionsRes.json();

//       this.renderContents({ id: null, sections, cart });

//       const myDrawer = document.querySelector('cart-drawer');
//       if (myDrawer) myDrawer.classList.add('is-empty');
//     } catch (error) {
//       // silent fail
//     }
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     if (!cartLink) return;

//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
//       this.setSummaryAccessibility(cartDrawerNote);
//     }

//     setTimeout(() => {
//       this.classList.add('animate', 'active');
//     });

//     this.addEventListener(
//       'transitionend',
//       () => {
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement =
//           this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');

//     setTimeout(() => {
//       requestAnimationFrame(() => {
//         this.bundleSync();
//       });
//     }, 300);
//   }

//   close() {
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute(
//         'aria-expanded',
//         !event.currentTarget.closest('details').hasAttribute('open')
//       );
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     const inner = this.querySelector('.drawer__inner');
//     if (inner && inner.classList.contains('is-empty')) {
//       inner.classList.remove('is-empty');
//     }

//     this.productId = parsedState.id;

//     // Pause observer while we wholesale replace innerHTML
//     this._pauseObserver();

//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);

//       if (!sectionElement) return;
//       sectionElement.innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });

//     // Resume observer after DOM settles
//     this._resumeObserver();

//     // ── TIMER: re-bind to fresh #countdown after re-render ──
//     requestAnimationFrame(() => {
//       if (parsedState.cart) {
//         handleCartTimerState(parsedState.cart.item_count);
//       } else {
//         fetch('/cart.js')
//           .then(r => r.json())
//           .then(cart => handleCartTimerState(cart.item_count))
//           .catch(() => {
//             const stored = localStorage.getItem(CART_TIMER_KEY);
//             if (stored) startCartTimer(false);
//           });
//       }
//     });
//     // ── END TIMER ──

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser()
//       .parseFromString(html, 'text/html')
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       { id: 'cart-drawer', selector: '#CartDrawer' },
//       { id: 'cart-icon-bubble' },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// // ============================================================
// // CART DRAWER ITEMS
// // ============================================================

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);

// // ============================================================
// // TIMER INIT ON PAGE LOAD
// // ============================================================

// document.addEventListener('DOMContentLoaded', () => {
//   fetch('/cart.js')
//     .then(r => r.json())
//     .then(cart => handleCartTimerState(cart.item_count))
//     .catch(() => {
//       const stored = localStorage.getItem(CART_TIMER_KEY);
//       if (stored) startCartTimer(false);
//     });
// });

// // Running code End here 

// ============================================================
// CART TIMER UTILITIES
// ============================================================

const CART_TIMER_KEY = 'cartTimerEnd';
const CART_TIMER_DURATION_MS = 10 * 60 * 1000; // 10 minutes
const CART_TIMER_EXPIRED_MSG = 'Your cart is running out! Complete your order now.';

let cartTimerInterval = null;

function getTimerEls() {
  return {
    display: document.querySelector('#countdown'),
    text: document.querySelector('#timer-text'),
  };
}

function formatCartTime(seconds) {
  const m = String(Math.floor(seconds / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${m}:${s}`;
}

function stopCartTimer() {
  if (cartTimerInterval) {
    clearInterval(cartTimerInterval);
    cartTimerInterval = null;
  }
}

function showCartTimerExpired() {
  const { display, text } = getTimerEls();
  if (display) display.textContent = '00:00';
  if (text) text.textContent = CART_TIMER_EXPIRED_MSG;
}

function startCartTimer(forceReset) {
  stopCartTimer();
  const { display } = getTimerEls();
  if (!display) return;

  let endTime = localStorage.getItem(CART_TIMER_KEY);
  if (!endTime || forceReset) {
    endTime = Date.now() + CART_TIMER_DURATION_MS;
    localStorage.setItem(CART_TIMER_KEY, String(endTime));
  } else {
    endTime = parseInt(endTime, 10);
    if (Date.now() >= endTime) { showCartTimerExpired(); return; }
  }

  function tick() {
    const { display: d } = getTimerEls();
    const remaining = Math.floor((endTime - Date.now()) / 1000);
    if (remaining <= 0) {
      stopCartTimer();
      localStorage.removeItem(CART_TIMER_KEY);
      showCartTimerExpired();
      return;
    }
    if (d) d.textContent = formatCartTime(remaining);
  }

  tick();
  cartTimerInterval = setInterval(tick, 1000);
}

function handleCartTimerState(itemCount) {
  if (itemCount === 0) {
    stopCartTimer();
    localStorage.removeItem(CART_TIMER_KEY);
    return;
  }
  const stored = localStorage.getItem(CART_TIMER_KEY);
  if (stored && Date.now() >= parseInt(stored, 10)) {
    localStorage.removeItem(CART_TIMER_KEY);
    startCartTimer(true);
    return;
  }
  startCartTimer(!stored);
}

// ============================================================
// CART DRAWER
// ============================================================

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // ── State flags ──────────────────────────────────────────
    //
    // _cartUpdateInProgress
    //   Set to true the moment a USER clicks +/- on a main item.
    //   While true, bundleSync() will NOT dispatch any 'change'
    //   events, so it cannot interfere with Dawn's in-flight
    //   Shopify API call. Released inside renderContents() once
    //   Dawn has finished its full fetch-and-re-render cycle.
    //
    // _bundleSyncing
    //   Re-entrancy guard. Prevents bundleSync from calling
    //   itself recursively while it is already dispatching a
    //   'change' event on the addon input.
    //
    // _observerPaused
    //   Silences the MutationObserver while we write to the DOM
    //   ourselves (so we don't react to our own mutations).
    //
    this._cartUpdateInProgress = false;
    this._bundleSyncing = false;
    this._observerPaused = false;
    this._cartUpdateLockTimer = null;
    this.bundleTimer = null;

    this.bundleSync();

    // Debounced MutationObserver
    this.bundleObserver = new MutationObserver(() => {
      if (this._observerPaused) return;
      clearTimeout(this.bundleTimer);
      this.bundleTimer = setTimeout(() => {
        requestAnimationFrame(() => this.bundleSync());
      }, 350);
    });

    this.bundleObserver.observe(this, { childList: true, subtree: true });

    // Detect USER-initiated quantity changes (event delegation)
    this._bindQuantityInputListener();
  }

  // ── Quantity input listener ──────────────────────────────
  // Listens for 'change' events on any quantity input inside
  // the drawer. If the event was NOT dispatched by bundleSync
  // (we mark those with a data attribute), it means the user
  // clicked +/- on a main product, so we lock bundleSync out.
  _bindQuantityInputListener() {
    this.addEventListener('change', (evt) => {
      const input = evt.target;
      if (!input.classList.contains('quantity__input')) return;

      // Ignore events we dispatched ourselves
      if (input.dataset.bundleSyncDispatch === 'true') return;

      // User-initiated — lock bundleSync until Dawn re-renders
      this._lockCartUpdate();
    });
  }

  _lockCartUpdate() {
    this._cartUpdateInProgress = true;
    clearTimeout(this._cartUpdateLockTimer);
    // Safety timeout: release after 2 s in case renderContents
    // never fires (e.g. network error keeps Dawn from finishing)
    this._cartUpdateLockTimer = setTimeout(() => {
      this._cartUpdateInProgress = false;
    }, 2000);
  }

  _unlockCartUpdate() {
    clearTimeout(this._cartUpdateLockTimer);
    this._cartUpdateInProgress = false;
  }

  _pauseObserver() {
    this._observerPaused = true;
  }

  _resumeObserver() {
    setTimeout(() => { this._observerPaused = false; }, 50);
  }

  // ── bundleSync ───────────────────────────────────────────
  bundleSync() {
    // CRITICAL: do not run while Dawn is handling a user quantity update
    if (this._cartUpdateInProgress) return;
    if (this._bundleSyncing) return;

    const addonEl = document.getElementById('addon-new-product');
    if (!addonEl) return;

    let addonIds = [];
    try {
      const parsed = JSON.parse(addonEl.textContent || '[]');
      addonIds = Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
    } catch (e) { return; }

    const addonId = addonIds[addonIds.length - 1];
    const cartItems = [...this.querySelectorAll('.cart-item')];
    if (!cartItems.length) return;

    const addonItem = cartItems.find(item => Number(item.dataset.key) === addonId);
    if (!addonItem) return;

    const addonInput = addonItem.querySelector('.quantity__input');
    const excludedIds = new Set([addonId, ...addonIds]);
    const mainItems = cartItems.filter(item => !excludedIds.has(Number(item.dataset.key)));

    let totalQty = 0;
    mainItems.forEach(item => {
      const input = item.querySelector('.quantity__input');
      totalQty += parseInt(input?.value || 0, 10);
    });

    if (totalQty === 0) { this.clearCartAndRefreshUI(); return; }
    if (!addonInput) return;

    const current = parseInt(addonInput.value, 10);
    if (current === totalQty) return; // already in sync, no write needed

    // Mark the dispatch so _bindQuantityInputListener ignores it
    this._bundleSyncing = true;
    this._pauseObserver();

    addonInput.dataset.bundleSyncDispatch = 'true';
    addonInput.value = totalQty;
    addonInput.dispatchEvent(new Event('change', { bubbles: true }));

    requestAnimationFrame(() => {
      delete addonInput.dataset.bundleSyncDispatch;
    });

    // Release after Dawn has had time to finish the addon update
    setTimeout(() => {
      this._bundleSyncing = false;
      this._resumeObserver();
    }, 800);
  }

  async clearCartAndRefreshUI() {
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }).then(r => r.json());

      const cart = await fetch('/cart.js').then(r => r.json());
      const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble').then(r => r.json());

      this.renderContents({ id: null, sections, cart });

      const myDrawer = document.querySelector('cart-drawer');
      if (myDrawer) myDrawer.classList.add('is-empty');
    } catch (error) {
      // silent fail
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => { this.classList.add('animate', 'active'); });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      requestAnimationFrame(() => this.bundleSync());
    }, 300);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner?.classList.contains('is-empty')) inner.classList.remove('is-empty');

    this.productId = parsedState.id;

    // Silence the observer while replacing innerHTML
    this._pauseObserver();

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this._resumeObserver();

    // Dawn finished — release the cart update lock so bundleSync
    // can run again now that the DOM reflects the correct quantities.
    this._unlockCartUpdate();

    // ── Timer: re-bind to fresh #countdown ───────────────────
    requestAnimationFrame(() => {
      if (parsedState.cart) {
        handleCartTimerState(parsedState.cart.item_count);
      } else {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => handleCartTimerState(cart.item_count))
          .catch(() => {
            const stored = localStorage.getItem(CART_TIMER_KEY);
            if (stored) startCartTimer(false);
          });
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// ============================================================
// CART DRAWER ITEMS
// ============================================================

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ============================================================
// TIMER INIT ON PAGE LOAD
// ============================================================

document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => handleCartTimerState(cart.item_count))
    .catch(() => {
      const stored = localStorage.getItem(CART_TIMER_KEY);
      if (stored) startCartTimer(false);
    });
});